import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';

export default function FAQ() {
  return (
    <section className='FAQ'>
      <div className="container">
        <h2 className="tittle mb-5">Часто задаваемые <span>вопросы</span></h2>
        <Accordion>
          <AccordionItem>
              <AccordionItemHeading>
                  <AccordionItemButton>
                    У вас есть рассрочка ?
                  </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                  <p>
                    По многочисленным просьбам наших клиентов мы расширяем услуги рассрочки с нашими партнёрами! 

                    ‼️ Для регистрации в приложении нужны документы удостоверяющие личность и зарплатная карта! На пенсионные карты рассрочки нет!

                    📲 Теперь Вы можете быстро и удобно оформить рассрочку через приложения наших партнёров таких как: ANORBANK, UZUM NASIYA, Zoodmall § zoodpay
                  </p>
              </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
              <AccordionItemHeading>
                  <AccordionItemButton>
                    Где находится ваш магазин
                  </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                  <p>
                    Корпусная мебель от производителя по оптовым ценам Находится 

                    Юнусабадском районе 7 квартл
                    Улица Майкургон 49

                    Мягкая мебель от производителя по оптовым ценам Находится 
                    По адресам 
                    1.Юнусабадский район улица Богишамол 260а 
                    2. Чиланзарский район 23 квартал улица Ширин 27
                  </p>
              </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem>
              <AccordionItemHeading>
                  <AccordionItemButton>
                  Как насчёт доставки?
                  </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                  <p>
                  Доставка установка по городу Ташкент бесплатная  только подем нв этаж платный 

Также при установке корпусной мебели должно быть нужное пространство для сборки лежа!
 При  вертикальной сборке есть дополнительная оплата

При установке мягкой мебели если мебель не пролетает в входную дверь то и если придётся разбирать её на месте это услуга тоже платная
                  </p>
              </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem>
              <AccordionItemHeading>
                  <AccordionItemButton>
                  Изготавливаете вы по индивидуальным Размерам?
                  </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                  <p>
                  Да мягкую мебель изготовим любой размер и расцветку 
Есть бесплатная услуга выезд мастера на дом с каталогами тканей и расцветок 

Кухонную мебель изготовим под ваш размер 

Корпусную мебель 90% готовую продаем некоторые модели изготовим под ваш размер 

Также изготовим Матрасы под ваш размер
                  </p>
              </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem>
              <AccordionItemHeading>
                  <AccordionItemButton>
                  Если у вас гарантия на мебель?
                  </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                  <p>
                  Да конечно  у нас есть гарантия от 1-5 лет в зависимости от вида мебели
                  </p>
              </AccordionItemPanel>
          </AccordionItem>

        </Accordion>
      </div>
    </section>
  )
}
